import FilterCardDisclosureController from "../lib/filter_card_disclosure"

// Agent dashboard Filters card — the server-rendered twin of the React
// FilterDropdown (#13753): lead-type checkbox changes are a DRAFT (the
// multi-select trigger label follows them client-side); Done submits the
// form once; Cancel / X / Escape / outside click put the committed boxes
// back. Clear All is TERMINAL, like the React card's: it unchecks every
// lead type and submits at once. The form's hidden `date_preset` field
// (owned by the Date card) carries the committed preset, so a submit from
// here preserves the applied date window.
export default class extends FilterCardDisclosureController {
  static targets = ["wrapper", "button", "panel", "option"]

  readCommitted() {
    return this.optionTargets.map((box) => box.checked)
  }

  restoreDraft() {
    if (!this.committed) return
    this.optionTargets.forEach((box, i) => this.setChecked(box, this.committed[i]))
  }

  commit() {
    if (this.optionTargets.every((box, i) => box.checked === this.committed?.[i])) return false
    const form = this.form()
    if (!form) return false
    form.requestSubmit()
    return true
  }

  // Reset only this card's dimension (lead_types) and apply immediately —
  // the Date card's window is untouched. With nothing to clear it just closes.
  clearAll(event) {
    event?.preventDefault()
    const anyChecked = this.optionTargets.some((box) => box.checked)
    this.optionTargets.forEach((box) => this.setChecked(box, false))
    if (!anyChecked && this.committed?.every((checked) => !checked)) {
      this.close()
      return
    }
    const form = this.form()
    if (form) form.requestSubmit()
  }

  // Dispatching change keeps the multi-select trigger label ("All" / "N
  // selected") in step with a programmatic check/uncheck.
  setChecked(box, checked) {
    if (box.checked === checked) return
    box.checked = checked
    box.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
